import { useRoute } from 'vue-router'

export function useLocaleTo() {
  const route = useRoute()
  function localeTo(to) {
    if (typeof to !== 'object' || !to.name) return to
    const locale = route.params.locale || localStorage.getItem('locale') || 'en'
    return { ...to, params: { locale, ...to.params } }
  }
  return { localeTo }
}
